/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Information about a volume that was backed up in an FSx snapshot.
*/
export class FsxVolumeBackupInfo {
  /**
  * The volume ID.
  */
  'volumeId'?: string;
  /**
  * The volume name.
  */
  'name'?: string;
  /**
  * The volume size in bytes.
  */
  'sizeBytes'?: number;
  /**
  * The volume junction path.
  */
  'junctionPath'?: string;
  /**
  * The volume type (RW, DP, LS).
  */
  'volumeType'?: string;
  /**
  * The AWS Backup recovery point ARN for this volume.
  */
  'recoveryPointArn'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "volumeId",
      "baseName": "volumeId",
      "type": "string",
      "format": ""
    },
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "sizeBytes",
      "baseName": "sizeBytes",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "junctionPath",
      "baseName": "junctionPath",
      "type": "string",
      "format": ""
    },
    {
      "name": "volumeType",
      "baseName": "volumeType",
      "type": "string",
      "format": ""
    },
    {
      "name": "recoveryPointArn",
      "baseName": "recoveryPointArn",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return FsxVolumeBackupInfo.attributeTypeMap;
  }

  public constructor() {
  }
}

